import { TOUR_TRANSLATIONS } from "../translations"

export const getEmbargoSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="embargo-filters"]',
            title: t.embargoFilters.title,
            content: t.embargoFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="embargo-table"]',
            title: t.embargoTable.title,
            content: t.embargoTable.content,
        },
        {
            target: '[data-tour="embargo-create-report"]',
            title: t.embargoCreateReport.title,
            content: t.embargoCreateReport.content,
        },
    ]
}
